module.exports = __webpack_public_path__ + "img/employee_1.bf33bef4.jpg";